import { UserChallenge } from "../types/challenge";

// The single definition of "active", mirroring the API's
// User::hasTrainingAccess(): only is_active === true grants training access,
// so a missing flag never counts.
export const isChallengeActive = (challenge: UserChallenge): boolean =>
  challenge.is_active === true;

export const activeChallenges = (user: {
  challenges?: UserChallenge[] | null;
}): UserChallenge[] => (user.challenges ?? []).filter(isChallengeActive);
